import './../agent_page.css'
import financial from '../../../assets/services/financial.jpg'
import banking from '../../../assets/services/banking.jpg'
import insurance from '../../../assets/services/insurance.jpg'
import travel from '../../../assets/services/travel.jpg'
import ayushman_bharat from '../../../assets/services/ayushman_bharat.jpg'
import employment from '../../../assets/services/employment.jpg'
import passport from '../../../assets/services/passport.jpg'
import pancard from '../../../assets/services/pancard.jpg'
import shopping from '../../../assets/services/shopping.jpg'
import loan from '../../../assets/services/loan.jpg'
import seller from '../../../assets/services/seller.png'
import { AppContext } from '../../../provider'
import React, { useContext, useState, useEffect } from 'react'
import { ServiceDetails } from './service_details'
import { getAgentDataList } from '../../../controller/agent_data_controller'


const services = [
  { title: "Financial", img: financial },
  { title: "Banking", img: banking },
  { title: "Insurance", img: insurance },
  { title: "Travel", img: travel },
  { title: "Ayushman Bharat", img: ayushman_bharat },
  { title: "Employment", img: employment },
  { title: "Passport", img: passport },
  { title: "PAN Card", img: pancard },
  { title: "Assisted Shopping", img: shopping },
  { title: "Loan", img: loan, badge: "NEW" },
  { title: "Seller On Board", img: seller, badge: "NEW" },
];


export const ServicesGrid = () => {
  const [agentData, setAgentData] = useState([]);
  useEffect(() => {

    async function getdata() {
      const loginType = localStorage.getItem('loginType');
      if (loginType === 'Admin') {
        let result = await getAgentDataList();
        setAgentData(result);
      }
    };
    getdata();
  }, []);
  const { setSidebarIndex, setPageIndex, pageIndex, externalService, setExternalService } = useContext(AppContext);
  return (
    <div>
      <div className="services-container">
        <h2 className="services-title">Services</h2>
        {pageIndex === 1 ? <ServiceDetails selectedOption={externalService} /> :
          <div className="services-grid">
            {services.map((item, i) => (
              <div onClick={() => {
                setExternalService(item.title);
                console.log(item.title);
                setPageIndex(1);
              }} className="service-card" key={i}>
                {item.badge && <span className="service-badge">{item.badge}</span>}
                <img src={item.img} alt={item.title} className="service-image" />
                <div className="service-title">{item.title}</div>
              </div>
            ))}
          </div>
        }
      </div>
      {localStorage.getItem('loginType') === 'Admin' && (
        <div style={{ backgroundColor: 'rgba(246, 246, 249, 1)' }}>
          <p className='title-demo'>Agent Balance</p>
          {agentData.length === 0 ? <span style={{ margin: '20px 50px' }}>No data found</span> :
            <div style={{ width: '100%', minHeight: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div className='content-div-demo' style={{ marginTop: '20px', paddingBottom: '20px' }}>
                <div style={{ display: 'flex', justifyItems: 'space-around' }}>
                  <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '33%', fontWeight: 'bold' }} title="Agent Username">Agent Username</div>
                  <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '33%', fontWeight: 'bold' }} title="Agent Email">Agent Email</div>
                  <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '33%', fontWeight: 'bold' }} title="Balance">Balance</div>
                </div>
                <hr style={{ margin: '10px 20px' }} />
                {agentData.map((payment, index) => (
                  <div key={index}>
                    <div style={{ display: 'flex', justifyItems: 'space-around' }}>
                      <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '33%' }} title={payment[0]}>{payment[0]}</div>
                      <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '33%' }} title={payment[1]}>{payment[1]}</div>
                      <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '33%' }} title={payment[2]}>{payment[2]}</div>
                    </div>
                    {agentData.length !== index + 1 ? <hr style={{ margin: '10px 20px' }} /> : ''}
                  </div>
                ))}
              </div>
            </div>
          }
          <div style={{ height: '100px' }}></div>
        </div>
      )}
    </div>

  );
}
